import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import './WhatsappChat.css';
import firebaseConfig from '../../pages/firebase/firebaseConfig';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const WhatsappChat = () => {
    const [phoneNumber, setPhoneNumber] = useState('');

    useEffect(() => {
        const fetchPhoneNumber = async () => {
            try {
                const querySnapshot = await db.collection('whatsappnumber').get(); // Update with your collection name
                if (!querySnapshot.empty) {
                    const firstDoc = querySnapshot.docs[0]; // Get the first document in the collection
                    const data = firstDoc.data();
                    setPhoneNumber(data.mobileNumber); // Update 'mobileNumber' to match your field name
                } else {
                    console.error('No documents found!');
                }
            } catch (error) {
                console.error('Error fetching phone number:', error);
            }
        };

        fetchPhoneNumber();
    }, []);

    const handleWhatsAppClick = () => {
        if (phoneNumber) {
            const whatsappUrl = `https://wa.me/${phoneNumber}`; // Use the fetched phone number
            window.open(whatsappUrl, '_blank'); // Opens WhatsApp or WhatsApp Web in a new tab
        } else {
            console.error('Phone number is not available.');
        }
    };

    return (
        <div className="whatsapp-container" onClick={handleWhatsAppClick}>
            <div className='gifBg'>
                <img
                   src="/Whatsapp.gif"
                    alt="WhatsApp"
                    className="whatsapp-icon" // Add the CSS class
                />
            </div>
        </div>
    );
};

export default WhatsappChat;
